import {useEffect} from 'react';
import {LiveGroup} from '@/components/main/live/group/LiveGroup';
import {useParams, useNavigate} from 'react-router-dom';
import {LiveGroupAward} from '@/components/main/live/group/award/LiveGroupAward';

export default function Live() {
  const {type} = useParams();
  const queryParams = new URLSearchParams(location.search);
  const categoryName = queryParams.get('categoryName');
  const navigate = useNavigate();

  useEffect(() => {
    if (
      !type ||
      !(['game', 'bora', 'sports'].includes(type) || /award20\d{2}/.test(type))
    ) {
      navigate(`/live/all`);
    }
  }, [type, navigate]);

  if (type && ['game', 'bora', 'sports'].includes(type)) {
    try {
      return <LiveGroup liveType={type} categoryName={categoryName} />;
    } catch (error) {}
  } else if (/award20\d{2}/.test(type)) {
    try {
      return <LiveGroupAward liveType={type} />;
    } catch (error) {}
  }
  return null;
}
